<template>
  <div class="pic">
    <img v-for="(item, index) in picList" :key="index" :src="item" @click="toMenu"/>
  </div>
</template>

<script>
export default {
  name: 'pic',
  computed: {
    picList() {
      const data = JSON.parse(sessionStorage.getItem('picItem'));
      return data.detailPicUrlList;
    },
  },
  methods: {
    toMenu() {
      const data = JSON.parse(sessionStorage.getItem('picItem'));
      this.$router.push({
        path: '/booking/menu/default',
        query: {
          name: data.productPrimaryTypeName,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.pic {
  text-align: center;
  padding-bottom: 20px;
  img {
    display: block;
    width: 940px;
    margin: auto;
  }
}
</style>
